import React, { useState } from 'react';
import CancelFormCreationDialog from '../../../../../components/modals/CancelFormCreationDialog';
import { useDispatch } from 'react-redux';
import { cancelCreation } from '../../../../../features/upload/uploadSlice';
import { reset } from '../../../../../features/stepper/stepperSlice';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';

const CancelModalManager: React.FC = () => {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  const openModal = () => setOpen(true);

  const closeModal = () => setOpen(false);

  const handleCancel = () => {
    setOpen(false);
    dispatch(cancelCreation());
    dispatch(reset());
    navigate('/');
  };

  return (
    <>
      <CloseIcon sx={{ cursor: 'pointer' }} onClick={openModal} />
      <CancelFormCreationDialog open={open} onClose={closeModal} onSubmit={handleCancel} />
    </>
  );
};

export default CancelModalManager;
